import React from "react";
import {useParams, NavLink} from "react-router";
import {ArrowBackIos} from "@mui/icons-material";
import {Button, Paper, Stack, Box, Typography} from "@mui/material";
import BuyerName from "../../components/buyer/BuyerDetail/BuyerName.tsx";
import {useLocationFormState} from "../../components/buyer/BuyerForm/BuyerUpdateForm";
import BuyerUpdateFormProvider from "../../components/buyer/BuyerForm/BuyerUpdateFormProvider";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const BuyerUpdateEditPage = () => {
    
    useTitle(t`Update Buyer`);

    const { buyerId: id } = useParams();
    
    return (
        <Box data-testid="Buyer-update-form">
            <Paper sx={ { padding: "2em" } }>
                <Stack direction="column" spacing={1}>
                    <Typography
                        sx={ { flex: '1 1 100%' } }
                        variant="h6"
                        component="div"
                        data-testid="Buyer-update-title"
                    >
                        <Trans>Edit Buyer</Trans>:  <BuyerName id={id}/>
                    </Typography>
                    <BuyerUpdateFormProvider
                        id={id}
                        cancelButton={
                            <Button size="medium" variant="contained" color="inherit" startIcon={<ArrowBackIos />}
                                    component={NavLink}
                                    to=".."
                                    relative="path"
                                    viewTransition={true}
                            >
                                <Trans>Cancel</Trans>
                            </Button>
                        }
                        initialFormState={useLocationFormState}
                    />
                </Stack>
            </Paper>
        </Box>
    )
}

export default BuyerUpdateEditPage;
